import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid } from 'semantic-ui/semantic-ui-imports';
import { groupAddons } from 'services/addons';
import { useData } from '../../../contexts/data';
import { AddonOption, AddonCategory } from '../../../Types/Aggregates';
import TextAndPicture from '../TextAndPicture';
import './index.scss';

function DescriptionAndAddons() {
  const { t } = useTranslation();
  const { activeUserInputs, activeAggregate, availableAddons } = useData();
  const [addonCategories, setAddonsCategories] = React.useState<
    AddonCategory[]
  >([]);

  React.useEffect(() => {
    // Resolve addon IDs to full objects from availableAddons
    let resolvedAddons = activeUserInputs.addons;
    if (resolvedAddons?.length && availableAddons?.length) {
      const firstAddon = resolvedAddons[0];
      if (typeof firstAddon === 'number' || typeof firstAddon === 'string') {
        resolvedAddons = resolvedAddons
          .map((id: number | string) =>
            availableAddons.find((a) => a.id === Number(id))
          )
          .filter(Boolean);
      }
    }
    setAddonsCategories(groupAddons(resolvedAddons, false));
  }, [activeUserInputs.addons, availableAddons]);

  return (
    <div className="description">
      <Grid>
        <Grid.Row>
          <h2 className="description__header">
            {t(`resultsPage.descriptionAndAddons.header`)}
          </h2>
        </Grid.Row>
        <Grid.GridRow>
          <h3 className="description__aggregate__name">
            {activeAggregate?.name || '-'}
          </h3>
        </Grid.GridRow>
        <Grid.GridRow>
          <div
            className="description__aggregate__description"
            dangerouslySetInnerHTML={{
              __html:
                activeAggregate?.description.replaceAll(/\r\n/g, '<br/>') ||
                t('resultsPage.descriptionAndAddons.missingDescription'),
            }}
          ></div>
        </Grid.GridRow>
        {activeUserInputs?.addons && !!activeUserInputs?.addons.length && (
          <>
            <Grid.GridRow>
              <h3 className="description__addons">
                {t(`resultsPage.descriptionAndAddons.aggregateAddonsHeader`)}
              </h3>
            </Grid.GridRow>
            <Grid.GridRow>
              <p className="description__addons-description">
                {t(
                  `resultsPage.descriptionAndAddons.aggregateAddonsDescription`
                )}
              </p>
            </Grid.GridRow>
            {addonCategories.map(
              (cat: AddonCategory) =>
                !!cat?.addons?.length && (
                  <div key={cat.id}>
                    <Grid.GridRow>
                      <h4>{cat.name}</h4>
                    </Grid.GridRow>
                    <Grid.GridRow>
                      {cat.addons.map((addon: AddonOption) => (
                        <TextAndPicture
                          key={addon.id}
                          name={addon.name}
                          text={addon.description}
                          img={addon.image || ''}
                          alt={addon.name}
                        />
                      ))}
                    </Grid.GridRow>
                  </div>
                )
            )}
          </>
        )}
      </Grid>
    </div>
  );
}

export default DescriptionAndAddons;
